import { FC } from 'react';
import { TransactionCategory } from '@bts-web/data-layer/server';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { PillBar } from '../common';
import { TransactionsTranslationsKeysResult } from './utils/getTransactionsTranslations';

const ALL = 'ALL';

interface TransactionsFilterHeaderProps {
  setCategory: (categories: TransactionCategory) => void;
  category: TransactionCategory | undefined;
  translations: TransactionsTranslationsKeysResult;
  hasCryptoTransfers?: boolean;
  hasStaking?: boolean;
}

type TranslationKeySubset = Extract<
  | 'tradeFilterPill'
  | 'cryptoTransferFilterPill'
  | 'corporateActionFilterPill'
  | 'nonUserInitiatedFilterPill'
  | 'cryptoActionFilterPill'
  | 'stakingFilterPill',
  keyof TransactionsTranslationsKeysResult
>;

type FilterPillValues =
  | 'TRADE'
  | 'CRYPTO_TRANSFER'
  | 'CORPORATE_ACTION'
  | 'NON_USER_INITIATED'
  | 'CRYPTO_ACTION'
  | 'STAKING';

const translationValueMap: Record<TranslationKeySubset, FilterPillValues> = {
  tradeFilterPill: 'TRADE',
  cryptoTransferFilterPill: 'CRYPTO_TRANSFER',
  corporateActionFilterPill: 'CORPORATE_ACTION',
  nonUserInitiatedFilterPill: 'NON_USER_INITIATED',
  stakingFilterPill: 'STAKING',
  cryptoActionFilterPill: 'CRYPTO_ACTION',
};

const TransactionsFilterHeader: FC<TransactionsFilterHeaderProps> = ({
  category,
  setCategory,
  translations,
  hasCryptoTransfers,
  hasStaking,
}) => {
  const { t } = useClientTranslation();

  const transactionsCategoryList: TranslationKeySubset[] = [
    'tradeFilterPill',
    ...(hasCryptoTransfers ? (['cryptoTransferFilterPill'] as const) : []),
    'corporateActionFilterPill',
    'nonUserInitiatedFilterPill',
    ...(hasStaking ? (['stakingFilterPill'] as const) : []),
    'cryptoActionFilterPill',
  ];

  const items = [
    { label: t('all'), value: ALL },
    ...transactionsCategoryList.map((category) => ({
      label: t(translations[category]),
      value: translationValueMap[category],
    })),
  ];

  const onChange = (value: string) => {
    setCategory((value === ALL ? undefined : value) as TransactionCategory);
  };

  return (
    <PillBar
      items={items}
      defaultValue={ALL}
      value={category ?? ALL}
      onValueChange={onChange}
    />
  );
};

export { TransactionsFilterHeader };
